import styled from 'styled-components'

export const ArticleWrapper = styled.div`
    display: flex;
    flex-flow: row;
    flex-wrap: wrap;
    justify-content: space-between;
`

export const ParagraphWrapper = styled.div`
    display: flex;
    flex-flow: row;
    flex-wrap: nowrap;
    width: 80%
    justify-content: space-around;
    padding: 10px;
`
